const replaceHome = url => (url === '__home__' ? '' : url);

const generateLink = (ctaInternalEntry = [], ctaSwitch, ctaExternalLink, openInNewWindow) => ({
  href: ctaSwitch ? ctaExternalLink : ctaInternalEntry[0] && `/${replaceHome(ctaInternalEntry[0].uri)}`,
  target: openInNewWindow ? '_blank' : '_self',
});

export default generateLink;
